export function parseIntervalInput(input: string): { value: number; unit: string } {
  const match = input.match(/^(\d+)([hdwm])$/);
  if (!match) {
    throw new Error("Invalid interval format. Use number followed by 'h', 'd', 'w', or 'm'.");
  }
  const [, value, unit] = match;
  return { value: parseInt(value, 10), unit };
}

export function intervalToMs(interval: string): number {
  const { value, unit } = parseIntervalInput(interval);
  switch (unit) {
    case 'h':
      return value * 60 * 60 * 1000;
    case 'd':
      return value * 24 * 60 * 60 * 1000;
    case 'w':
      return value * 7 * 24 * 60 * 60 * 1000;
    case 'm':
      return value * 30 * 24 * 60 * 60 * 1000;
    default:
      throw new Error("Invalid interval unit. Use 'h', 'd', 'w', or 'm'.");
  }
}
